import React, { HTMLProps } from "react";

import { InputRadioSyle } from "./styles";

type RadioFieldProps = HTMLProps<HTMLInputElement> & {
  errorCondition?: boolean;
  errorMessage?: string;
};

const RadioField = ({ children, ...rest }: RadioFieldProps): JSX.Element => {
  return (
    <InputRadioSyle>
      <input type="radio" {...rest} />
      {children && <label htmlFor={rest.id}>{children}</label>}
    </InputRadioSyle>
  );
};

export default RadioField;
